// extracted by mini-css-extract-plugin
export var menuIcon = "_p6-0";
export var menuIconInline = "_p6-1";